import { faArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text, TextButton } from '@modusign/design-system';
import { Dispatch, SetStateAction } from 'react';

import { ResourceRoleSubject } from '@app/features/authorization';
import SelectedMemberGroupArea from '@app/features/authorization/components/PermissionAssigneeListModal/AddAssigneeForm/SelectedMemberGroupArea';
import SearchedMemberGroupTab from '@app/features/authorization/components/SearchedMemberGroupTab';
import isEqualResourceRoleSubject from '@app/features/authorization/utils/isEqualResourceRole';
import useDebouncedState from '@app/hooks/useDebouncedState';

function BatchPermissionGrantModalRoleSubjectList({
  resourceRoleSubjects,
  setResourceRoleSubjects,
}: {
  resourceRoleSubjects: ResourceRoleSubject[];
  setResourceRoleSubjects: Dispatch<SetStateAction<ResourceRoleSubject[]>>;
}) {
  const [debouncedValue, actualValue, setActualValue] = useDebouncedState('', 300);

  return (
    <>
      <SelectedMemberGroupArea
        keyword={actualValue}
        selectedResourceRoleSubjects={resourceRoleSubjects}
        onKeywordChange={setActualValue}
        onSelectedResourceRoleSubjectsChange={setResourceRoleSubjects}
      />

      <Flex flexDirection="column" gap={4} mt={7}>
        {debouncedValue ? (
          <Flex justifyContent="space-between">
            <Text fontWeight="medium">{`'${debouncedValue}' 검색 결과`}</Text>
            <TextButton onClick={() => setActualValue('')}>
              <Box as={FontAwesomeIcon} icon={faArrowRotateLeft} />
              <Text ml="2px">검색 초기화</Text>
            </TextButton>
          </Flex>
        ) : (
          <Text fontSize="md" fontWeight="medium">
            전체 멤버 · 그룹
          </Text>
        )}
        <SearchedMemberGroupTab
          disabled={resourceRoleSubjects.length === 20}
          keyword={debouncedValue}
          selectedSubjects={resourceRoleSubjects}
          tooltipContent="한 번에 20개의 멤버·그룹만 적용할 수 있습니다."
          onToggle={(v) =>
            setResourceRoleSubjects((subjects) =>
              subjects.some((s) => isEqualResourceRoleSubject(s, v))
                ? subjects.filter((s) => !isEqualResourceRoleSubject(s, v))
                : [...subjects, v]
            )
          }
        />
      </Flex>
    </>
  );
}

export default BatchPermissionGrantModalRoleSubjectList;
